import EFOcats_import_html from '../../../core/v2/import/efocats_import_html.js';
import EFOcats_import_lang from '../../../core/v2/import/efocats_import_lang.js';
import EFOcats_import_style from '../../../core/v2/import/efocats_import_style.js';
import EFOcats_pattern_factory from '../../../core/v2/pattern/efocats_pattern_factory.js';
import EFOcats from '../../../js/v2/efocats.js';
import EFOcats_event_before_leave from '../event/efocats_event_before_leave.js';
import EFOcats_event_leave from '../event/efocats_event_leave.js';
import EFOcats_event_modal from '../event/efocats_event_modal.js';
import EFOcats_iwatani_event_addCheck from '../event/efocats_iwatani_event_addCheck.js';
import EFOcats_iwatani_event_birthday from '../event/efocats_iwatani_event_birthday.js';
import EFOcats_iwatani_making from '../making/efocats_iwatani_making.js';
import EFOcats_iwatani_settingdata from '../setting/efocats_iwatani_settingdata.js';
import EFOcats_iwatani_submit from '../submit/efocats_iwatani_submit.js';
import EFOcats_iwatani_validate_checkbox from '../validate/efocats_iwatani_validate_checkbox.js';
import EFOcats_iwatani_validate_space from '../validate/efocats_iwatani_validate_space.js';

class EFOcats_iwatani extends EFOcats {
  constructor() {
    super();

    this.account = {
      id: 3117,
      form_id: 1,
    };

    this.pass = {
      min: 4, // パスワード最低入力数
      max: 10, // パスワード最大入力数
      limit: ['hankaku'],
    };

    // 設定ファイル追加
    EFOcats_import_html.load(require('../html/export-html-iwatani.html'));
    EFOcats_import_style.load(require('../html/export-style-iwatani.html'));
    EFOcats_import_lang.load(require('../lang/export-lang-iwatani.js'));

    // 処理クラスをカスタマイズしたものに差し替える
    this.settingdata = new EFOcats_iwatani_settingdata();
    this.making = new EFOcats_iwatani_making();
    this.submit = new EFOcats_iwatani_submit();

    // 元フォーム取得用のセレクタ
    this.formQuery = 'form[name="form1"]';

    // フレーム設置先
    this.targetQurey = '.cat-modal-content';

    // イベント追加
    this.events.modal = new EFOcats_event_modal();
    this.events.birthday = new EFOcats_iwatani_event_birthday();
    this.events.addCheck = new EFOcats_iwatani_event_addCheck();
    this.events.before_leave = new EFOcats_event_before_leave();
    this.events.leave = new EFOcats_event_leave();

    this.events.page.pager_back = true;

    // 送信ボタンのセレクタ
    this.submit.submitbtn_query = 'form[name="form1"] .submit';

    // 最下部スクロールでモーダルが開くまでの時間（ミリ秒）
    this.show_modal_time = 0;

    // 許可デバイス
    this.AllowDevices = ['SP'];

    // モーダルを一度でも開いたかどうか
    this.open_modal = false;

    // タイトルリスト
    this.making.titleList = {
      注文内容確認: 'ご注文商品に間違いが無ければ、「お客様情報入力へ」へお進みください。',
      name01: 'お名前をご入力ください。',
      sex: '性別をご選択ください。',
      year: '生年月日をご入力ください。',
      email: 'メールアドレスをご入力ください。',
      password: '希望するパスワードをご入力ください。（半角英数4〜10文字）',
      reminder: 'パスワードを忘れた際の質問・回答をご入力ください。',
      zip01: '自宅住所をご入力ください。',
      tel01: '電話番号をご入力ください。',
      chk01: '申込条件について同意のうえ、お進みください。',
      'agree[]': '個人情報の取り扱い・利用規約について同意のうえ、お進みください。',
    };

    // インフォメーションリスト
    this.making.infoList = {
      tel01: 'ハイフンは入れずにご記入ください',
      chk01:
        '<span class="attention">下記に同意頂くことが申込条件となります。</span><br/>当社からメール・ＤＭ・お電話でお得なキャンペーンなどのご案内を差し上げることに同意いただける方（登録後、「MYページ」から配信停止も可能です）',
    };

    // ラベル表示リスト
    this.making.showlabelList = ['name01', 'email', 'password', 'reminder', 'tel01'];

    // パターン
    EFOcats_pattern_factory.create('single-katakana', this, {
      sei: 'name01',
      mei: 'name02',
      sei_kana: 'kana01',
      mei_kana: 'kana02',
    });

    // 属性情報読み込み
    this.settingdata.attrjson = require('../json/attr.json');

    this.validations.includespace = new EFOcats_iwatani_validate_space();
    this.validations.checkbox = new EFOcats_iwatani_validate_checkbox();
  }

  /**
   * 環境チェック
   */
  check_environment() {
    if (!super.check_environment()) {
      return false;
    }

    // 戻ってきた時は起動しない
    if (window.location.pathname.indexOf('pay-sample/conf') >= 0 || document.referrer.indexOf('pay-sample/conf') >= 0) {
      return false;
    }

    return true;
  }
}

if (document.getElementsByClassName('error2').length === 0) {
  // 実行
  window.efocats = new EFOcats_iwatani();
  efocats.main();
}
